// React Compoment
import React from 'react'

// Features
import { Routes } from '../../routes'
import { AdminPages } from '../../features/dashboard'

// Layout
import DashLayout from '../../layouts/dashboard/dashLayout'

const AdminView = () => {
    const pathname = window.location.pathname

    return (
        <DashLayout>
            {pathname === Routes.ADMIN_LIST ?
                <AdminPages />
                :
                <AdminPages />
            }

        </DashLayout>
    )
}

export default AdminView;